import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';

export function getProductReqObj(
  versionId: string,
  productId: string,
  language?: string,
  channel?: string,
): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products/${productId}`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
      ...(language && { 'Accept-Language': language }),
      ...(channel && { 'X-Amway-Channel': channel }),
    },
    retries: 0,
  };
}

export function getProductArrayReqObj(versionId: string): RequestOptions {
  return {
    url: `/comproductas/${versionId}/products`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}
export default { getProductReqObj, getProductArrayReqObj };
